export default "__VITE_ASSET__576bc219__"